import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isString, pick, keys } from 'lodash';
import { decoratePathWithStitchClientAppId } from 'utils/decorate-path-with-stitch-client-app-id';

/**
 * A HOC to decorate a RouterLink component with the stitchClientAppId prefix for private
 * routes within the application.
 *
 * @param {React.component} RouterLink - the Link component for the router
 * @returns {React.component} Link - the decorated Link component
 **/
const linkFactory = RouterLink => {
  class Link extends Component {
    static propTypes = {
      ...RouterLink.propTypes,
      className: PropTypes.string,
      disabled: PropTypes.bool,
      history: PropTypes.object,
      match: PropTypes.object,
      location: PropTypes.object,
    };

    static defaultProps = {
      ...RouterLink.defaultProps,
      className: '',
      disabled: false,
      onClick: () => {},
    };

    handleClick = event => {
      if (this.props.disabled) {
        event.preventDefault();
        return false;
      }

      this.props.onClick(event);
    };

    render() {
      const {
        className,
        children,
        disabled,
        to,
        match,
        onClick, // eslint-disable-line no-unused-vars
        ...otherProps
      } = this.props;
      const stitchClientAppId =
        (match && match.params && match.params.stitchClientAppId) || null;

      const decoratedTo = isString(to)
        ? decoratePathWithStitchClientAppId(to, stitchClientAppId)
        : {
            ...to,
            pathname: decoratePathWithStitchClientAppId(
              to.pathname,
              stitchClientAppId
            ),
          };

      const linkProps = pick(otherProps, keys(RouterLink.propTypes));

      return (
        <RouterLink
          {...linkProps}
          onClick={this.handleClick}
          to={decoratedTo}
          className={className}
          disabled={disabled}
        >
          {children}
        </RouterLink>
      );
    }
  }

  return Link;
};

export default linkFactory;
export { linkFactory };
